"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getStyles = exports.StyledContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _castArray2 = _interopRequireDefault(require("lodash-es/castArray"));

var _find2 = _interopRequireDefault(require("lodash-es/find"));

var _filter2 = _interopRequireDefault(require("lodash-es/filter"));

var _get2 = _interopRequireDefault(require("lodash-es/get"));

var _field = _interopRequireDefault(require("./_field"));

var _button = _interopRequireDefault(require("./_button"));

var _popover = _interopRequireDefault(require("../../atoms/_popover"));

var _icon = _interopRequireDefault(require("../../atoms/icon"));

var _text = _interopRequireDefault(require("../../atoms/text"));

var _textInput = _interopRequireWildcard(require("../../atoms/text-input"));

var _fontIcon = _interopRequireWildcard(require("../../atoms/font-icon"));

var _label = _interopRequireDefault(require("../../atoms/label"));

var _selectableList = _interopRequireDefault(require("../selectable-list"));

var _stack = _interopRequireDefault(require("../stack"));

var _pixelcalculations = require("../../_utils/pixelcalculations");

var _validations = require("../../_utils/validations");

var _versions = require("../../_utils/versions");

var _tokens = require("../../../tokens");

var _context = require("../../context");

var _utilities = require("../../_utils/utilities");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject12() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  padding-left: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n              text-transform: ", ";\n              color: ", ";\n            "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n            text-transform: none;\n            color: ", ";\n          "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          text-transform: ", ";\n          color: ", ";\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n          max-width: 90%;\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          width: 100%;\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: ", ";\n  ", ";\n  text-align: start;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  ", ";\n\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    max-height: 360px;\n    overflow-y: auto;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  &:focus {\n    outline: none;\n  }\n\n  ", ", ", " {\n    padding-left: 1px;\n    margin-right: 8px;\n    width: initial;\n    height: 13px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    background: #f7f7f7;\n    text-indent: 8px;\n  }\n\n  ", " {\n    margin-left: 8px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var statusIcon = 'icon-circle-filled';

var getColors = function getColors(props) {
  var buttonColors = (0, _versions.getColor)(props, 'button').secondary;
  var inputColor = (0, _versions.getColor)(props, 'input');
  var dropdown = (0, _versions.getColor)(props, 'dropdown');
  return {
    buttonColors: buttonColors,
    inputColor: inputColor,
    dropdown: dropdown
  };
};

var getViews = function getViews(props) {
  var _getColors = getColors(props),
      buttonColors = _getColors.buttonColors,
      inputColor = _getColors.inputColor;

  return {
    "default": {
      text: buttonColors.text,
      icon: buttonColors.icon,
      background: buttonColors.background,
      border: buttonColors.border,
      hoverBackground: buttonColors.backgroundHover,
      hoverBorder: buttonColors.borderHover,
      focusBackground: buttonColors.backgroundFocus,
      focusBorder: buttonColors.borderFocus,
      activeBackground: buttonColors.backgroundActive,
      activeBorder: buttonColors.borderActive
    },
    error: {
      text: buttonColors.text,
      icon: buttonColors.icon,
      background: buttonColors.background,
      border: inputColor.borderError,
      hoverBackground: buttonColors.backgroundHover,
      hoverBorder: inputColor.borderError,
      focusBackground: buttonColors.backgroundFocus,
      focusBorder: inputColor.borderError,
      activeBackground: buttonColors.backgroundActive,
      activeBorder: inputColor.borderError
    }
  };
};

var sizes = {
  "default": {
    lineHeight: (0, _pixelcalculations.subtract)(_tokens.misc.button["default"].height, '2px'),
    minWidth: '145px'
  },
  badge: {
    lineHeight: (0, _pixelcalculations.subtract)(_tokens.misc.badge["default"].height, '2px'),
    minWidth: '145px'
  }
};

var getStyles = function getStyles(props) {
  var appearanceStyles = props.error ? _objectSpread({}, getViews(props).error) : _objectSpread({}, getViews(props)["default"]);
  var properties = (0, _versions.getProperties)(props, 'button');
  var sizeStyles = props.renderType === 'badge' ? _objectSpread({}, sizes.badge) : _objectSpread({}, sizes["default"]);

  var styles = _objectSpread({}, appearanceStyles, sizeStyles);

  if (props.icon && !props.selectedLabel && !props.placeholder && props.renderType !== 'field') {
    styles.padding = 0;
    styles.minWidth = '36px';
  } else if (props.icon && (props.selectedLabel || props.placeholder)) styles.minWidth = '169px';

  if (props.noMinWidth) {
    styles.minWidth = 'initial';
  }

  styles.height = properties.height;
  styles.radius = properties.radius;
  return styles;
};

exports.getStyles = getStyles;

var SearchTextWrapper = _styledComponents["default"].div(_templateObject(), _textInput["default"].Element, _textInput.IconWrapper);

var ListWrapper = _styledComponents["default"].div(_templateObject2(), _icon["default"].Element, _fontIcon.StyledIcon);

var Content = _styledComponents["default"].div(_templateObject3(), ListWrapper);

var StyledContent = _styledComponents["default"].span(_templateObject4(), _tokens.fonts.weight.normal, function (props) {
  return props.fullWidth ? (0, _styledComponents.css)(_templateObject5()) : (0, _styledComponents.css)(_templateObject6());
}, function (props) {
  return props.grouped ? (0, _styledComponents.css)(_templateObject7(), props.textTransform, getColors(props).inputColor.text) : props.placeholder ? (0, _styledComponents.css)(_templateObject8(), getColors(props).inputColor.placeholder) : props.selected ? (0, _styledComponents.css)(_templateObject9(), props.textTransform, getColors(props).inputColor.text) : null;
});

exports.StyledContent = StyledContent;

var Error = function Error(props) {
  return _react["default"].createElement(_label["default"], {
    type: "error"
  }, props.msg);
};

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  //eslint-disable-line
  function Dropdown(_props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      var _this$getSelectedLabe = _this.getSelectedLabelAndGroups(nextProps),
          selectedLabel = _this$getSelectedLabe.selectedLabel,
          selectedGroups = _this$getSelectedLabe.selectedGroups;

      _this.setState({
        selectedLabel: selectedLabel,
        selectedGroups: selectedGroups
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedLabelAndGroups", function (props) {
      var selectedLabel, selectedGroups;

      if (props.grouped || (0, _validations.isNil)(props.selected)) {
        selectedLabel = props.placeholder;
      }

      if (props.grouped && !(0, _validations.isNil)(props.selected)) {
        selectedGroups = props.selected;
        return {
          selectedLabel: selectedLabel,
          selectedGroups: selectedGroups
        };
      }

      if (props.grouped && (0, _validations.isNil)(props.selected)) {
        selectedGroups = _this.getSelectedGroups();
        return {
          selectedLabel: selectedLabel,
          selectedGroups: selectedGroups
        };
      }

      if (!props.multi) {
        var child = (0, _find2["default"])((0, _castArray2["default"])(props.children), function (child) {
          return child.props.value === props.selected;
        });
        selectedLabel = (0, _get2["default"])(child, 'props.label', '');
        return {
          selectedLabel: selectedLabel,
          selectedGroups: selectedGroups
        };
      }

      var children = (0, _filter2["default"])((0, _castArray2["default"])(props.children), function (child) {
        return (0, _castArray2["default"])(props.selected).includes(child.props.value);
      });
      selectedLabel = children.map(function (child) {
        return child.props.label;
      }).toString();
      return {
        selectedLabel: selectedLabel,
        selectedGroups: selectedGroups
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedGroups", function () {
      var selected = {};
      var value = _this.props.multi ? [] : '';

      _react["default"].Children.forEach(_this.props.children, function (group) {
        var groupId = group.props.value;
        selected[groupId] = value;
      });

      return selected;
    });

    _defineProperty(_assertThisInitialized(_this), "onSelection", function (_ref) {
      var group = _ref.group,
          v = _ref.v;

      if (!group) {
        _this.props.onSelection(v);

        _this.closePopover();

        return;
      }

      if (v) {
        var pg = _this.state.selectedGroups;
        var ng = {};

        if (_this.props.multi) {
          ng = _objectSpread({}, pg, _defineProperty({}, group, v));
        } else {
          ng[group] = v;
        }

        _this.props.onSelection(ng);
      }

      _this.closePopover();
    });

    _defineProperty(_assertThisInitialized(_this), "closePopover", function () {
      if (!_this.props.multi) _this.listWrapper.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (e) {
      _this.setState({
        searchString: e.target.value.toString().toLowerCase()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddEntry", function (e) {
      if (e.keyCode === 13 && e.target.value) {
        e.preventDefault();
        e.stopPropagation();

        _this.props.onAddEntry(e.target.value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getIcon", function (props, version) {
      var size = props.size || 16;
      var iconName = props.icon;

      if (props.level) {
        var color = getColors(version).dropdown.status;
        return _react["default"].createElement(_fontIcon["default"], {
          size: 12,
          color: color[props.level]
        }, statusIcon);
      }

      if (_utilities.iconPattern.test(iconName)) {
        return _react["default"].createElement(_fontIcon["default"], {
          size: size
        }, iconName);
      }

      return _react["default"].createElement(_icon["default"], {
        size: size,
        name: iconName
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getChildren", function (props, version) {
      var valueToStatus = {};

      var children = _react["default"].Children.map(props.children, function (child) {
        if (_this.props.type === 'status') {
          valueToStatus[child.props.value] = child.props.level;
        }

        if (child.props.label.toString().toLowerCase().includes(_this.state.searchString)) {
          return _react["default"].createElement(_selectableList["default"].Item, {
            value: child.props.value
          }, _react["default"].createElement(_stack["default"], {
            align: "left"
          }, (child.props.icon || child.props.level) && _this.getIcon(child.props, version), _react["default"].createElement(Label, null, child.props.label)));
        }
      });

      _this.valueToStatus = valueToStatus;
      if (!children) return null;

      if (children.length === 0) {
        return _react["default"].createElement(_text["default"], {
          size: 6
        }, "No Result");
      }

      return children;
    });

    _defineProperty(_assertThisInitialized(_this), "makeContent", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          grouped = _this$props.grouped,
          multi = _this$props.multi,
          selected = _this$props.selected,
          searchable = _this$props.searchable,
          version = _this$props.version,
          bordered = _this$props.bordered;
      var content, lists;

      if (grouped) {
        lists = [];

        _react["default"].Children.forEach(children, function (group) {
          var groupValue = group.props.value;
          var groupLabel = group.props.label;

          var list = _react["default"].createElement(_selectableList["default"], {
            lean: true,
            key: groupValue,
            label: groupLabel,
            bordered: false,
            multi: multi,
            selected: _this.state.selectedGroups[groupValue],
            onSelection: function onSelection(v) {
              return _this.onSelection({
                group: groupValue,
                v: v
              });
            }
          }, _this.getChildren(group.props, version));

          lists.push(list);
        });
      } else {
        lists = _react["default"].createElement(_selectableList["default"], {
          lean: true,
          bordered: false,
          multi: multi,
          selected: selected,
          onSelection: function onSelection(v) {
            return _this.onSelection({
              v: v
            });
          }
        }, _this.getChildren(_this.props, version));
      }

      content = _react["default"].createElement(Content, null, searchable && _react["default"].createElement(SearchTextWrapper, null, _react["default"].createElement(_textInput["default"], {
        "native": true,
        icon: "icon-search",
        placeholder: "Search",
        onKeyUp: _this.onAddEntry,
        onChange: _this.onSearch,
        bordered: bordered
      })), _react["default"].createElement(ListWrapper, {
        tabIndex: '0',
        innerRef: function innerRef(e) {
          return _this.listWrapper = e;
        }
      }, lists));
      return content;
    });

    var _this$getSelectedLabe2 = _this.getSelectedLabelAndGroups(_props),
        _selectedLabel = _this$getSelectedLabe2.selectedLabel,
        _selectedGroups = _this$getSelectedLabe2.selectedGroups;

    _this.state = {
      searchString: '',
      selectedLabel: _selectedLabel,
      selectedGroups: _selectedGroups
    };
    return _this;
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          label = _this$props2.label,
          renderType = _this$props2.renderType,
          fullWidth = _this$props2.fullWidth,
          position = _this$props2.position,
          placeholder = _this$props2.placeholder,
          disabled = _this$props2.disabled,
          listWidth = _this$props2.listWidth,
          icon = _this$props2.icon,
          borderOnHoverOnlyFromProps = _this$props2.borderOnHoverOnly;
      var content = this.makeContent();
      var adjustVerticalAlign = renderType === 'field' ? true : false;
      var align = this.props.align === 'left' || this.props.align === 'right' ? this.props.align : 'right';
      var iconColor = null;

      if (this.props.type === 'status') {
        var level = this.valueToStatus[this.props.selected];
        iconColor = getColors(this.props.version).dropdown.status[level];
      }

      var _ref2 = (0, _versions.getProperties)(this.props, 'dropDown') || this.props,
          textTransform = _ref2.textTransform;

      var borderOnHoverOnly = this.props.type === 'status' || borderOnHoverOnlyFromProps;
      return _react["default"].createElement("div", null, _react["default"].createElement(_popover["default"], {
        align: align,
        content: content,
        fullWidth: fullWidth,
        listWidth: listWidth,
        position: position,
        adjustVerticalAlign: adjustVerticalAlign,
        contentDisabled: disabled,
        version: this.props.version
      }, renderType === 'field' ? _react["default"].createElement(_field["default"], _extends({}, this.props, {
        label: label,
        selectedLabel: this.state.selectedLabel,
        placeholder: placeholder,
        textTransform: textTransform
      })) : _react["default"].createElement(_button["default"], _extends({}, this.props, {
        selectedLabel: this.state.selectedLabel,
        placeholder: placeholder,
        icon: this.props.type === 'status' ? statusIcon : icon,
        size: this.props.type === 'status' && 12,
        iconColor: iconColor,
        textTransform: textTransform,
        borderOnHoverOnly: borderOnHoverOnly
      }))), this.props.error ? _react["default"].createElement(Error, {
        msg: this.props.error
      }) : null);
    }
  }]);

  return Dropdown;
}(_react["default"].Component);

var Label = _styledComponents["default"].span(_templateObject10(), _tokens.spacing.xsmall);

Dropdown.MenuItem = _styledComponents["default"].div(_templateObject11());
Dropdown.Group = _styledComponents["default"].div(_templateObject12());
Dropdown.propTypes = {
  align: _propTypes["default"].oneOf(['left', 'right']),

  /** disabled flag */
  disabled: _propTypes["default"].bool,

  /** error indicator  */
  error: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),

  /** Toggle render types */
  renderType: _propTypes["default"].oneOf(['badge', 'button', 'field']),

  /** only applicable for select field */
  label: _propTypes["default"].string,

  /** Take full width of parent */
  fullWidth: _propTypes["default"].bool,
  noMinWidth: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  icon: _propTypes["default"].string,

  /** Where to place the popover */
  position: _propTypes["default"].oneOf(['top', 'bottom']),

  /** multipe selection */
  multi: _propTypes["default"].bool,

  /** make the list searchable based on label */
  searchable: _propTypes["default"].bool,

  /** default selected */
  selected: _propTypes["default"].any,

  /** callback on selection */
  onSelection: _propTypes["default"].func,

  /** callback on pressing enter in search box */
  onAddEntry: _propTypes["default"].func,
  borderOnHoverOnly: _propTypes["default"].bool,
  listWidth: _propTypes["default"].string,
  bordered: _propTypes["default"].bool
};
Dropdown.defaultProps = {
  align: 'left',
  disabled: false,
  error: false,
  fullWidth: false,
  noMinWidth: false,
  renderType: 'button',
  placeholder: 'Select',
  position: 'bottom',
  multi: false,
  searchable: false,
  onSelection: _noop2["default"],
  onAddEntry: _noop2["default"],
  bordered: false
};
Dropdown.displayName = 'Dropdown';

var _default = (0, _context.withVersion)(Dropdown);

exports["default"] = _default;